// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ADea","content":"styles_content__olbC9"};